// Document type groups (CL) used for membership checks.
// Centralized to avoid "magic" arrays repeated across the template, computed,
// methods and validations of the CL manual document form.

// Export documents
export const EXPORT_TYPES = Object.freeze(['CL110', 'CL111', 'CL112'])

// Types that allow amounts in another currency
export const OTHER_CURRENCY_TYPES = Object.freeze(['CL33', 'CL34', 'CL46', 'CL52', 'CL56', 'CL61'])

// Credit/debit notes and export notes (require a reference)
export const NOTE_TYPES = Object.freeze(['CL56', 'CL61', 'CL111', 'CL112'])

// Exempt documents (exempt invoice/receipt)
export const EXEMPT_TYPES = Object.freeze(['CL34', 'CL41'])

// Receipts (boletas)
export const BOLETA_TYPES = Object.freeze(['CL39', 'CL41'])

// Types without receiver municipality/city/address (receipts + export)
export const NO_RECEIVER_LOCATION_TYPES = Object.freeze([...BOLETA_TYPES, ...EXPORT_TYPES])
